import { IconProps } from "@/src/services/utils/types/globals";

AccountIcon.defaultProps = {
  color: "#1078CA",
};

export default function AccountIcon(props: IconProps) {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.5 14.0268C1.5 12.6381 2.61928 11.5122 4 11.5122H14C15.3807 11.5122 16.5 12.6381 16.5 14.0268C16.5 15.4156 15.3807 16.5415 14 16.5415H4C2.61928 16.5415 1.5 15.4156 1.5 14.0268Z" fill={props.color}/>
      <path d="M12.75 5.6665C12.75 7.53046 11.2389 9.0415 9.37497 9.0415C7.51099 9.0415 5.99996 7.53046 5.99996 5.6665C5.99996 3.80254 7.51099 2.2915 9.37497 2.2915C11.2389 2.2915 12.75 3.80254 12.75 5.6665Z" fill={props.color}/>
    </svg>
  );
}
